import { accountsAPI } from 'configs/axios';

export const loginUser = (values: {
  service?: string;
  email: string;
  password: string;
  region?: string;
}) => {
  return accountsAPI({
    url: '/users/authn',
    method: 'POST',
    data: values,
    config: { headers: {} },
  });
};

export const logoutUser = () => {
  return accountsAPI({
    url: '/users/logout',
    method: 'POST',
  });
};

export const fetchUser = (signal?: AbortSignal | undefined) => {
  return accountsAPI({ url: '/users/me', method: 'GET', config: { signal } });
};

export const getRefreshToken = (signal?: AbortSignal | undefined) => {
  return accountsAPI({ url: '/users/refresh', method: 'GET', config: { signal } });
};

export const verifypassword = (data: { password: string }) => {
  return accountsAPI({ url: '/users/verifypassword', method: 'POST', data });
};
